import React, { Component } from 'react';

import InputBlock from 'components/input/block/InputBlock';
import InputBlockIcon from 'components/input/block/InputBlockIcon';
import Input from 'components/input/Input';
import InputMask from 'components/input/mask/InputMask';
import PropTypes from 'prop-types';

import { I18n } from '../../translate';

import './InputGroup.scss';

class InputGroup extends Component {
  static propTypes = {
    autoComplete: PropTypes.string,
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    description: PropTypes.node,
    guide: PropTypes.bool,
    icon: PropTypes.string,
    keepCharPositions: PropTypes.bool,
    mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
    maxLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    onChange: PropTypes.func,
    pipe: PropTypes.func,
    placeholder: PropTypes.string,
    placeholderChar: PropTypes.string,
    showMask: PropTypes.bool,
    type: PropTypes.string,
    value: PropTypes.string,
    translate: PropTypes.bool,
    children: PropTypes.node,
    onKeyPress: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    forwardRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    handleKeyDown: PropTypes.func,
    disabled: PropTypes.bool
  };

  render() {
    const {
      autoComplete,
      description,
      guide,
      keepCharPositions,
      mask,
      maxLength,
      name,
      onChange,
      pipe,
      placeholder = '',
      placeholderChar,
      showMask,
      translate = true,
      type,
      value,
      onKeyPress,
      onBlur,
      onFocus,
      inputClassName,
      handleKeyDown,
      forwardRef,
      disabled,
      ...props
    } = this.props;

    const InputBlockComponent = this.props.icon ? InputBlockIcon : InputBlock;
    let InputComponent = Input;
    let maskedInputProps = {};

    if (mask) {
      InputComponent = InputMask;
      maskedInputProps = {
        guide,
        keepCharPositions,
        mask,
        pipe,
        placeholderChar,
        showMask
      };
    }

    const { 'data-test': dataTest, ...others } = props;

    return (
      <InputBlockComponent name={name} translate={translate} {...others}>
        {description && (
          <p className="secondary mt__0">
            {translate ? <I18n html label={description} /> : description}
          </p>
        )}

        <InputComponent
          id={name}
          autoComplete={autoComplete}
          maxLength={maxLength}
          name={name}
          onChange={onChange}
          onKeyPress={onKeyPress}
          onBlur={onBlur}
          onFocus={onFocus}
          placeholder={placeholder}
          type={type}
          translate={translate}
          value={value}
          className={inputClassName}
          handleKeyDown={handleKeyDown}
          ref={forwardRef}
          disabled={disabled}
          data-test={dataTest}
          {...maskedInputProps}
        />

        {this.props.children}
      </InputBlockComponent>
    );
  }
}

const ForwardedInputGroup = React.forwardRef((props, ref) => (
  <InputGroup {...props} forwardRef={ref} />
));

export default ForwardedInputGroup;
